import React, { useEffect, useState } from "react"
import { formatSeconds } from "../../js/functions";

export function RegistroInformeMensual({ registroDia }) {

  const [tiempoTotalDia, setTiempoTotalDia] = useState(null);

  useEffect(() => {
    setTiempoTotal(registroDia.fechaDia, registroDia.registro, registroDia.estado)
  }, []);

  function setTiempoTotal(fechaDia, registro, estado) {
    if(registro === "") { setTiempoTotalDia(""); return }
    else if(registro === "" && estado === "FESTIVO") { setTiempoTotalDia("FESTIVO"); return }
    else if(registro.trabajado === false) { setTiempoTotalDia(registro.motivoLibre); return }
    // else if(registro === "" && horario[new Date(fechaDia).getDay()].inicio === "") { setTiempoTotal(""); return }
    else if(registro.inicio === undefined) { setTiempoTotalDia(""); return }

    let pausas = "", totalSegundos = 0, total = "DIA SIN COMPLETAR";
    if (registro.pausas !== undefined && registro.pausas !== null) {
      if (registro !== "") {
        pausas = registro.pausas.filter(pausa => pausa.tipo !== 2)
      }
      else {
        pausas = ""
      }
    } 

    if (pausas !== "" && pausas.length > 0 && registro.fin !== undefined && pausas !== null) {
      for (let i = 0; i<pausas.length; i++) {
        if (pausas[i] !== undefined) {
          if (pausas[i].fin !== undefined){
            if (pausas.length === 1) { //solo si hay 1 pausa
              const segundosAux = pausas[0].inicio.seconds - registro.inicio.seconds
              const segundosAux2 = registro.fin.seconds - pausas[0].fin.seconds
              totalSegundos = segundosAux + segundosAux2
              total = formatSeconds(totalSegundos)
              //console.log("una pausa")
            } else if (pausas.length === 2) { //hay 2 pausas
              const segundosAux = pausas[0].inicio.seconds - registro.inicio.seconds
              const segundosAux2 = pausas[1].inicio.seconds - pausas[0].fin.seconds
              const segundosAux3 = registro.fin.seconds - pausas[1].fin.seconds
              totalSegundos = segundosAux + segundosAux2 + segundosAux3
              total = formatSeconds(totalSegundos)
              //console.log("2 pausas")
            } else { // hay mas de 2 pausas
              if (i === 0) { //primera pausa
              const segundosAux = pausas[i].inicio.seconds - registro.inicio.seconds
              totalSegundos = totalSegundos + segundosAux
              //console.log("tres pausas 1, segundos aux -> "+segundosAux+",    segundos totales -> "+totalSegundos)
              } else if (i < pausas.length) { //pausas intermedias
              const segundosAux = pausas[i].inicio.seconds - pausas[i-1].fin.seconds
              totalSegundos = totalSegundos + segundosAux
              //console.log("tres pausas 2, segundos aux -> "+segundosAux+",    segundos totales -> "+totalSegundos)
              } 
              if(i === pausas.length-1) { //ultima pausa
              const segundosAux = registro.fin.seconds - pausas[i].fin.seconds
              totalSegundos = totalSegundos + segundosAux
              //console.log("tres pausas 3, segundos aux -> "+segundosAux+",    segundos totales -> "+totalSegundos)
              total = formatSeconds(totalSegundos)
              }
            }
          }
        }
      }
    }
    else if (registro.fin !== undefined) {
      const totalSegundos = registro.fin.seconds - registro.inicio.seconds
      total = formatSeconds(totalSegundos)
    }
    if (registro === "" && total === "DIA SIN COMPLETAR") return ""
    setTiempoTotalDia(total)
  }

  function addColors(tiempoTotalDia, registro) {
    if (tiempoTotalDia === "DIA SIN COMPLETAR") return <td style={{backgroundColor: "#dfa9a9", fontSize: "12px", paddingInline: "2px"}}>{tiempoTotalDia}</td>
    else if (registro !== "" && registro.trabajado === false && registro.motivoLibre === "OTROS") return <td style={{backgroundColor: "#e8a1ea", fontSize: "12px", paddingInline: "2px"}}>{registro.comentarioLibre}</td>
    else if (registro !== "" && registro.trabajado === false) return <td style={{backgroundColor: "#e8a1ea", fontSize: "12px", paddingInline: "2px"}}>{tiempoTotalDia}</td>
    else if (tiempoTotalDia === "") return <td>{tiempoTotalDia}</td>
    else return <td style={{backgroundColor: "#d1e6c6"}}>{tiempoTotalDia}</td>
  }

  return (
    <>
      {addColors(tiempoTotalDia, registroDia.registro)}
    </>
  )
}